"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measures = void 0;
const clicks_1 = require("./clicks");
const cookieConversions_1 = require("./cookieConversions");
const cookieCPA_1 = require("./cookieCPA");
const cookieCPAPaid_1 = require("./cookieCPAPaid");
const cookieRevenue_1 = require("./cookieRevenue");
const cookieROAS_1 = require("./cookieROAS");
const cookieROASPaid_1 = require("./cookieROASPaid");
const cost_1 = require("./cost");
const predictedConversions_1 = require("./predictedConversions");
const predictedCPA_1 = require("./predictedCPA");
const predictedCPAPaid_1 = require("./predictedCPAPaid");
const predictedRevenue_1 = require("./predictedRevenue");
const predictedROAS_1 = require("./predictedROAS");
const predictedROASPaid_1 = require("./predictedROASPaid");
const sessions_1 = require("./sessions");
const totalConversions_1 = require("./totalConversions");
const totalConversionsCredits_1 = require("./totalConversionsCredits");
const totalConversionsValue_1 = require("./totalConversionsValue");
const visitors_1 = require("./visitors");
exports.measures = {
    clicks: {
        name: 'Clicks',
        query: clicks_1.clicks,
    },
    cookieConversions: {
        name: 'Cookie Conversions',
        query: cookieConversions_1.cookieConversions,
    },
    cookieCpa: {
        name: 'Cookie CPA',
        query: cookieCPA_1.cookieCPA,
    },
    cookieCPAPaid: {
        name: 'Cookie CPA (Paid)',
        query: cookieCPAPaid_1.cookieCPAPaid,
    },
    cookieRevenue: {
        name: 'Cookie Revenue',
        query: cookieRevenue_1.cookieRevenue,
    },
    cookieROAS: {
        name: 'Cookie ROAS',
        query: cookieROAS_1.cookieROAS,
    },
    cookieRoasPaid: {
        name: 'Cookie ROAS (Paid)',
        query: cookieROASPaid_1.cookieROASPaid,
    },
    cost: {
        name: 'Cost',
        query: cost_1.cost,
    },
    predictedConversions: {
        name: 'Predicted Conversions',
        query: predictedConversions_1.predictedConversions,
    },
    predictedCPA: {
        name: 'Predicted CPA',
        query: predictedCPA_1.predictedCPA,
    },
    predictedCPAPaid: {
        name: 'Predicted CPA (Paid)',
        query: predictedCPAPaid_1.predictedCPAPaid,
    },
    predictedRevenue: {
        name: 'Predicted Revenue',
        query: predictedRevenue_1.predictedRevenue,
    },
    predictedROAS: {
        name: 'Predicted ROAS',
        query: predictedROAS_1.predictedROAS,
    },
    predictedROASPaid: {
        name: 'Predicted ROAS (Paid)',
        query: predictedROASPaid_1.predictedROASPaid,
    },
    sessions: {
        name: 'Sessions',
        query: sessions_1.sessions,
    },
    visitors: {
        name: 'Visitors',
        query: visitors_1.visitors,
    },
    totalConversions: {
        name: 'Total Conversions',
        query: totalConversions_1.totalConversions,
    },
    totalConversionsCredits: {
        name: 'Total Conversions Credits',
        query: totalConversionsCredits_1.totalConversionsCredits,
    },
    totalConversionsValue: {
        name: 'Total Conversions Value',
        query: totalConversionsValue_1.totalConversionsValue,
    },
};
//# sourceMappingURL=index.js.map